export default __webpack_public_path__ + "public/images/services/Filter.png?a2233b2a";